<app-leveltwo [pageName]="'New Business Owners'">
  <div class="General">

      <h3>{{'BusinessDates.PageTitle'|translate}}</h3>
      <!--
      <h4>{{'BusinessDates.PropertyTaxPortal'|translate}}</h4>
      <h5>{{'BusinessDates.Awebsite'|translate}}: <a href="https://www.propertytax.lacounty.gov/">PROPERTYTAX.LACOUNTY.GOV</a></h5>
      -->
      <p [innerHTML]="'BusinessDates.ThePropertyTaxPortal'|translate"></p>
      <p>{{'BusinessDates.Eachyear'|translate}}</p>
      <p>{{'BusinessDates.Generally'|translate}}</p>
      <p>{{'BusinessDates.Thepurpose'|translate}}</p>
      <p [innerHTML]="'BusinessDates.Formorev2'|translate"></p>

      <link rel="stylesheet" type="text/css" href="//netdna.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css">
      <!--
<div class="container bootstrap snippets bootdey">
    <section id="news" class="white-bg padding-top-bottom">
        <div class="container bootstrap snippets bootdey">
            <div class="timeline">
                <div class="date-title">
                    <span>January</span>
                </div>
                <div class="row">
                    <div class="col-sm-6 news-item">
                        <div class="news-content">
                            <div class="date">
                                <p>1</p>

                            </div>
                          <ul>
                              <li>{{'BusinessDates.January1item1'|translate}}</li>
                              <li>{{'BusinessDates.January1item2'|translate}}</li>
                              <li>{{'BusinessDates.January1item3'|translate}}</li>
                              <li>{{'BusinessDates.January1item4'|translate}}</li>
                            </ul>

                        </div>
                    </div>

                    <div class="col-sm-6 news-item right">
                      <div class="news-content">
                          <div class="date">
                              <p>15</p>

                          </div>
                          <p>{{'BusinessDates.January15item'|translate}}</p>


                      </div>

                  </div>



                </div>



                <div class="date-title">
                    <span>February</span>
                </div>
                <div class="row">
                    <div class="col-sm-6 news-item">
                        <div class="news-content">
                            <div class="date">
                                <p>1</p>

                            </div>

                            <p>Second installment of real estate taxes is DUE (DELINQUENT after 5:00 PM on April 10).</p>
                        </div>
                    </div>

                    <div class="col-sm-6 news-item right">
                        <div class="news-content">
                            <div class="date">
                                <p>15</p>

                            </div>
                            <p>Deadline for timely filing of affidavits and claims for exemptions (late after 5:00 PM; a postmark before midnight is consid-ered timely) for personal and real property, including: Cemeteries · Colleges · Church and Religious · Exhibitors · Museums ·Owners of Historical Aircraft · Owners of Historical Wooden Vessels · Public Libraries · Public Schools · Welfare</p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
-->
    <!--
     <table>
        <tr>
          <th>{{'BusinessDates.January1'|translate}}</th>
          <td>
            <ul>
              <li>{{'BusinessDates.January1item1'|translate}}</li>
              <li>{{'BusinessDates.January1item2'|translate}}</li>
              <li>{{'BusinessDates.January1item3'|translate}}</li>
              <li>{{'BusinessDates.January1item4'|translate}}</li>
            </ul>

          </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.January15'|translate}}</th>
          <td>
            <ul>
              <li>{{'BusinessDates.January15item'|translate}}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.February1'|translate}}</th>
          <td>
            <ul>
              <li>{{'BusinessDates.February1item'|translate}}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.February15'|translate}}</th>
          <td>
          <ul>
            <li>{{'BusinessDates.February15item'|translate}}</li>
          </ul>
          </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.March1'|translate}}</th>
          <td>
          <ul>
          <li>{{'BusinessDates.March1item'|translate}}</li>
          </ul>
          </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.April1'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.April1item'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.April10'|translate}}</th>
          <td>
            <ul>
              <li>{{'BusinessDates.April10item1'|translate}}</li>
              <li>{{'BusinessDates.April10item2'|translate}}</li>
            </ul>
          </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.May7'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.May7item'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.June1'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.June1item1'|translate}}</li>
                <li>{{'BusinessDates.June1item2'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.June30'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.June30item1'|translate}}</li>
                <li>{{'BusinessDates.June30item2'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.July1'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.July1item'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.July2'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.July2item'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.August'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.Augustitem'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.August31'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.August31item'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.September'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.Septemberitem'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.October'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.Octoberitem1'|translate}}</li>
                <li>{{'BusinessDates.Octoberitem2'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.November1'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.November1item1'|translate}}</li>
                <li>{{'BusinessDates.November1item2'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.November30'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.November30item1'|translate}}</li>
                <li>{{'BusinessDates.November30item2'|translate}}</li>
              </ul>
            </td>
        </tr>
        <tr>
          <th>{{'BusinessDates.December10'|translate}}</th>
            <td>
              <ul>
                <li>{{'BusinessDates.December10item'|translate}}</li>
              </ul>
            </td>
        </tr>

      </table>


      <p>{{'BusinessDates.Ifthe'|translate}}</p>
      <p>{{'BusinessDates.Theprop'|translate}}</p>
      -->
  </div>
</app-leveltwo>
